import _ from "lodash";
import { useCallback, useMemo, useRef, useState } from "react";

import AlertModalContext, { defaultState } from "./AlertModalContext";
import type { AlertModalMessageProps } from "./types";

type Props = {
  children?: any;
};

export default function AlertModalProvider(props: Props) {
  const [state, setState] = useState<AlertModalMessageProps>(defaultState);

  const isShowingRef = useRef(false);

  const onCloseRef = useRef<Function>();

  const show = useCallback(
    (
      args: AlertModalMessageProps & {
        onClose?: () => any;
      }
    ) => {
      if (isShowingRef.current === true) return;

      const { title, message, buttons, onClose } = args;

      isShowingRef.current = true;
      setState({
        title,
        message,
        buttons,
      });

      onCloseRef.current = onClose;
    },
    [setState]
  );

  const hide = useCallback(() => {
    setState(defaultState);
    isShowingRef.current = false;

    if (_.isFunction(onCloseRef.current)) {
      onCloseRef.current();
      delete onCloseRef.current;
    }
  }, [setState]);

  const context = useMemo(() => {
    return {
      state,
      show,
      hide,
    };
  }, [state, show, hide]);

  return (
    <AlertModalContext.Provider value={context}>
      {props.children}
    </AlertModalContext.Provider>
  );
}

export { AlertModalProvider };
